export default "__VITE_ASSET__C2ojOO4p__"